/**
 * 文件路径: D:\XXY\MeiShan_Project\frontend\packages\enterprise-admin\src\main.ts
 * 应用主入口文件
 */

// ⚠️ Passive Event Fix 必须在所有其他导入之前执行
// 解决 Element Plus 组件触发的 Chrome Violation 警告
import { installPassiveEventFix } from './utils/passive-event-fix'
installPassiveEventFix()

import { createApp, markRaw, type Component } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import { TokenManager } from '@shared/api'
import { installElementPlusPopoverCloseFix, installProactiveTokenRefresh } from '@shared/utils'

// 样式导入
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@shared/styles/theme.css'
import '@shared/styles/form-standards.css'
import '@shared/styles/confirm-dialogs.css'
import './styles/app-theme.css'

// 设置默认暗色主题
document.documentElement.setAttribute('data-theme', 'dark')
document.documentElement.classList.add('dark')

// ✅ 统一修复：Element Plus 下拉/弹层点击空白无法收起问题
installElementPlusPopoverCloseFix()

// 创建应用实例
const app = createApp(App)

// 为本应用设置本地存储前缀，确保与其他后台并存登录互不干扰
if (import.meta?.env?.DEV) console.info('[App][enterprise-admin] bootstrap')
TokenManager.setKeyPrefix('enterprise_')

// 在 base 且 token 无效时跳转登录
try {
  const base = '/enterprise-admin/'
  const path = window.location.pathname
  if (path === base && !TokenManager.hasValidAuth()) {
    router.replace('/login')
  }
} catch {}

// 配置 Pinia 状态管理
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// 注册 Element Plus 图标（使用 markRaw 避免响应式包装导致性能问题）
const icons = ElementPlusIconsVue as Record<string, Component>
for (const [key, component] of Object.entries(icons)) {
  app.component(key, markRaw(component))
}

// 注册插件
app.use(pinia)
app.use(ElementPlus)
app.use(router)

// 主动 Token 续期：用户空闲后切回页面时静默刷新，避免首次加载卡顿
installProactiveTokenRefresh('/api/v1/')

// 挂载应用
app.mount('#app')
